import util from '../util';

//  analyze html in the string script tag and add to body middle 
function runScript(list) {
    var psScripts = Promise.resolve();
    list.forEach(m => {
        var s = m.match(/^\<script([^>]*)\>([\s\S]*)\<\\\/script\>$/);
        if (s) {
            // console.log(s);
            // <s cript> The case where there is code inside 
            if (s[2] && /\w/.test(s[2])) {
                psScripts = psScripts.then(() => {
                    new Function('window', s[2])(window);
                });
            }
            // <s cript> When tags have attributes ( Usually external links )
            else if (s[1]) {
                var attrObj = {};
                s[1].split(' ').forEach(item => {
                    if (item) {
                        var strs = item.match(/([\w]*)=(.*)/); //  reserve url the following parameters 
                        if (strs) {
                            // sync deffer  no such 
                            var key = strs[1] || '';
                            var value = (strs[2] || '')
                                .replace(/^['"]/, '')
                                .replace(/['"]$/, '');
                            if (key) {
                                attrObj[key] = value;
                            }
                        }
                    }
                });
                if (attrObj.src) {
                    psScripts = psScripts.then(() => {
                        return util.addScript(
                            attrObj.src,
                            true,
                            document,
                            attrObj
                        );
                    });
                }
            }
        }
    });
}

//  generate html,  and insert into el
export function decodeHtml(el, binding, vnode) {
    if (vnode.context.htmlData !== binding.value) {
        vnode.context.htmlData = binding.value;
        const reg = /\<script[^>]*\>[\s\S]*?\<\\\/script\>/g;
        //  analyze <script><\/script>,  Manual conversion to script loading 
        var value = binding.value || '';
        var mlist = value.match(reg);
        if (mlist) {
            el.innerHTML = value.replace(reg, '');
            runScript(mlist);
        } else {
            el.innerHTML = binding.value;
        }
    }
}
